import { TimeFill18Icon } from "@vygruppen/spor-icon-react";
import { isSameSecond } from "date-fns";
import { RecentlyUpdatedDialog } from "features/CenterContent/RoleContent/AlternativeTransport/MeasureOverview/MeasureOverviewColumn/MeasureCard/RecentlyUpdatedDialog";
import { PlanEventInformation } from "features/CenterContent/RoleContent/AlternativeTransport/MeasureOverview/types";
import { FC } from "react";
import { Box, Flex, Text } from "shared/components/Spor";
import { useThemeSemantic } from "shared/theme/themeSemantic";
import { formatMeasureCardDateTimeString } from "shared/utils/dateTimeUtils";
import { Semantics } from "shared/utils/semantics";

type MeasureCardFooterProps = {
  measure: PlanEventInformation;
  recentlyUpdated: boolean;
  acknowledgeLatestVersion: () => void;
  semantics: Semantics;
};

export const MeasureCardFooter: FC<MeasureCardFooterProps> = ({
  measure,
  recentlyUpdated,
  acknowledgeLatestVersion,
  semantics,
}) => {
  const theme = useThemeSemantic(semantics);

  const { information } = measure;

  return (
    <Flex alignItems="stretch" gap={1}>
      <Box pt={0.5}>
        <TimeFill18Icon color={theme.colorSemanticTextSecondary} />
      </Box>
      <Box color={theme.colorSemanticTextSecondary}>
        <Text variant="xs" fontWeight="bold">
          Opprettet: {formatMeasureCardDateTimeString(information.createdAt)}
        </Text>
        {!isSameSecond(information.createdAt, information.updatedAt) && (
          <Text variant="xs">
            Oppdatert: {formatMeasureCardDateTimeString(information.updatedAt)}
          </Text>
        )}
      </Box>

      <Flex
        flexGrow={1}
        justifyContent="flex-end"
        alignItems="flex-end"
        onClick={(e) => e.stopPropagation()}
      >
        {recentlyUpdated && (
          <RecentlyUpdatedDialog
            measure={measure}
            semantics={semantics}
            acknowledgeLatestVersion={acknowledgeLatestVersion}
          />
        )}
      </Flex>
    </Flex>
  );
};
